import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import {  useEffect, useState } from "react";
import MomSysMaterialByCompanyCreateButton from "../input/MomSysMaterialByCompanyCreateButton";
import MomSysMaterialByCompanyUpdateButton from "../input/MomSysMaterialByCompanyUpdateButton";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import getSchema from "../../lib/api/getSchema";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import AccessControl from "../functional/AccessControl";
import { Tooltip, toggleClass, } from '@grapecity/wijmo';
import "./gridEvent.css"

function MomSysMaterialByCompany ( props ) {

    const [grid, setGrid ] = useState();
    const [ schema, setSchema ] = useState ();
    const [ refresh, setRefresh ] = useState ();
    const [isEmpty, setIsEmpty] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect( ()=> {

        let mounted = true;

        (async ()=> {
            
            let schema = await getSchema("MomSysMaterialByCompany");

            if ( mounted ) {

                setSchema(schema);

            }

        })();

        return ( () => {

            mounted = false;

        } );

    },[]);

    useEffect(() => {
        let tooltip = new Tooltip();
        (async () => {
            if (grid) {
                grid.formatItem.addHandler((flex, element) => {
                    if (element.panel === flex.cells) {
                        let item = flex.rows[element.row].dataItem
                        let binding = flex.columns[element.col].binding
                        let data = item.customerDescription ? item.customerDescription : null;
                        toggleClass(element.cell, 'wj-has-notes', binding === "customerDescription" && data !== null );
                        if(binding === "customerDescription" && data !== null) {
                            tooltip.setTooltip(element.cell, `<h1>${data}<h1>`);
                        }
                    }
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    const onInitialized = ( grid ) => {

        grid.selectionMode = "Row";

        setGrid ( grid );

    }

    const onApiInitialized = ( api ) => {

        setRefresh ( api );

    }

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const onSuccess = ( msg ) => {
    
        notifySuccess ( msg );
    
    };

    const onLoadData = (data) => {
        setIsEmpty(data.length < 1 ? true : false)
    };

    const onAppendButtonAtFirst = () => {
        return (
            <BasicCrudScreenActionItemLayout>
                <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                    <MomSysMaterialByCompanyCreateButton
                        id = "MomSysMaterialByCompanyCreate"
                        schema = {schema}
                        refresh = {refresh}
                        onSuccess = {onSuccess}
                    />
                </AccessControl>

                <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch?"PATCH":"PUT")}>
                    <MomSysMaterialByCompanyUpdateButton
                        id = "MomSysMaterialByCompanyUpdate"
                        schema = {schema}
                        refresh = {refresh}
                        grid = {grid}
                        onSuccess = {onSuccess}
                        disabled={isEmpty ? true : false}
                    />
                </AccessControl>
            </BasicCrudScreenActionItemLayout>
        );
    };

    return (
        <BasicCrudScreenType
            id="MomSysVwMaterialByCompany"
            table="MomSysMaterialByCompany"
            view="MomSysVwMaterialByCompanyUpdate" 
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onLoadData={onLoadData}
            noCreate
            noEdit
            onAppendButtonAtFirst = {onAppendButtonAtFirst}
        />
    );

}

export default MomSysMaterialByCompany;
